module.exports = __webpack_public_path__ + "img/fi-roundup-400x263.87daee1e.jpg";